export default {
    namespaced: true,

    state: () => ({
        isLoggedIn: false,
        user: {
            id: null,
            prenom: '',
            nom: '',
            matricule: '',
            etablissement_libelle: '',
            etablissement_id: '',
            etablissement: null,
            role: '',
            email: ''
        }
    }),

    getters: {
        getLogged(state) {
            return state.isLoggedIn;
        },
        user(state) {
            return state.user;
        }
    },

    mutations: {
        SET_LOGGED(state, payload) {
            // console.log(payload);
            state.user = payload.user;
            state.isLoggedIn = payload.isLoggedIn;
        },
        SET_LOGGED_USER_INFO(state, payload) {
            state.user = payload.user;
        }
        /* SET_USER(state, user) {
            state.user = user;
        } */
    }
};
